import React from 'react';
import PropTypes from 'prop-types';
import {Button, Glyphicon} from 'react-bootstrap';
import SweetAlert from 'sweetalert2-react';

export default class DeletionConfirmBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalShown: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleModalConfirm = this.handleModalConfirm.bind(this);
  }

  showModal() {
    this.setState(
      {
        modalShown: true,
      },
      () => {
        document.querySelector('.delete-cancel').focus();
      },
    );
  }

  closeModal() {
    this.setState({
      modalShown: false,
    });
  }

  handleModalConfirm() {
    const {deleteAction} = this.props;
    deleteAction();
    this.closeModal();
  }

  render() {
    const {componentClass: RootComponent, className, itemName, alertText, DeleteButton, confirmButtonText} = this.props;
    const text = alertText ? alertText : `Please confirm that you wish to delete this ${itemName || 'item'}`;
    return (
      <RootComponent className={className}>
        <SweetAlert
          {...{
            title: 'Are you sure?',
            text,
            type: 'warning',
            show: this.state.modalShown,

            // buttonsStyling: false,
            onConfirm: this.handleModalConfirm,
            // confirmButtonClass: 'btn btn-primary',
            confirmButtonText,

            onCancel: this.closeModal,
            // cancelButtonClass: 'btn btn-danger delete-cancel',
            cancelButtonClass: 'delete-cancel',
            showCancelButton: true,
            reverseButtons: true,
          }}
        />
        {DeleteButton ? (
          <DeleteButton onClick={this.showModal} className="btn-show-confirm" />
        ) : (
          <Button onClick={this.showModal} bsStyle="danger" className="btn-round btn-show-confirm">
            <Glyphicon className="deletion" glyph="trash" />
          </Button>
        )}
      </RootComponent>
    );
  }
}

DeletionConfirmBox.propTypes = {
  componentClass: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  itemName: PropTypes.string,
  alertText: PropTypes.string,
  DeleteButton: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  deleteAction: PropTypes.func.isRequired,
  confirmButtonText: PropTypes.string.isRequired,
};

DeletionConfirmBox.defaultProps = {
  componentClass: 'span',
  confirmButtonText: 'Delete',
};
